export default __webpack_public_path__ + "static/media/bed_menu_item.ccc1abb5.svg";